export const NOMINATIONS_SENT = "NOMINATIONS_SENT";
export const NOMINATIONS_RECIEVED = "NOMINATIONS_RECIEVED";

export const setSentNominations = (data:any)=>{
    return {
        type:NOMINATIONS_SENT,
        payload:data
    }
}
export const setRecievedNominations = (data:any)=>{
    return {
        type:NOMINATIONS_RECIEVED,
        payload:data
    }
}